<script>
  // import Swiper core and required modules
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "swiper/css/scrollbar";
  import "swiper/css/autoplay";
  import Categories from "./categories.svelte";


  onMount(() => {
    window.scrollTo(0, 0);

    const user = localStorage.getItem("us");

    if (user === null || user === "") {
      navigate("/login");
    } else {
      getdata();
    }
  });

  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "types.php";
  const categories_api_url = API_END_POINT + "category.php";
  const size_api_url = API_END_POINT + "size.php";
  const color_api_url = API_END_POINT + "colors.php";
  const fetch_eight_api_url = API_END_POINT + "fetchproducts.php";

  const next = document.getElementById("next");
  const previous = document.getElementById("previous");

  let types = [];
  let categories = [];
  let sizes = [];
  let colors = [];
  let ten_products = [];
  let path;
  let page_previous;
  let page_next;
  let shop_set;
  let firstproduct;
  let lastproduct;

  const pathfromurl = window.location.pathname;
  let paths = pathfromurl.split("/");
  path = paths[2];

  if (path === undefined || path === "") {
    path = 0;
  } else {
    path = Number(paths[2]);
  }
  shop_set = path;
  // console.log("path : " + path);

  if (shop_set === 0) {
    page_next = 1;
  } else if (shop_set === 1) {
    page_previous = "";
    page_next = shop_set + 1;
  } else {
    page_previous = shop_set - 1;
    page_next = shop_set + 1;
  }

  // console.log(page_previous);
  // console.log(page_next);

  async function getdata() {
    const response = await fetch(api_url);
    const data = await response.json();
    types = data;

    // const category_response = await fetch(categories_api_url);
    // const category_response_data = await category_response.json();
    // categories = category_response_data;

    // const size_response = await fetch(size_api_url);
    // const size_response_data = await size_response.json();
    // sizes = size_response_data;

    // const colors_response = await fetch(color_api_url);
    // const colors_response_data = await colors_response.json();
    // colors = colors_response_data;

    const posts_response = await fetch(fetch_eight_api_url, {
      method: "POST",
      body: JSON.stringify({ page: path }),
    });
    const posts_response_data = await posts_response.json();
    ten_products = posts_response_data;

    firstproduct = ten_products[0];
    lastproduct = ten_products[9];

    // console.log(firstproduct);
    // console.log(lastproduct);

    if (
      lastproduct == null ||
      (lastproduct == "") | (lastproduct == undefined)
    ) {
      // console.log(lastproduct);
      document.getElementById("next").style.display = "none";
    }
  }

  function remove_placeholder() {
    const nodeList = document.querySelectorAll(".placeholder");
    for (var i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove("placeholder");
    }
  }
</script>

<svelte:head>
  <title>Shop Page</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <Link
                to="./"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-house-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                  />
                </svg>
              </Link>
            </li>
            <li class="list-item">
              <h6 class="title text-center">All Products</h6>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <div class="catagories-section section-gap-top-25">
    <div class="container">
      <Categories/>
    </div>
  </div>

  <!-- ...:::Start Search & Filter Section:::... -->
  <div class="search-n-filter-section section-gap-top-20">
    <div class="container">
      <!-- Start Search & Filter Area -->
      <div class="search-n-filter-area home-one">
        {#if categories != ""}
          <button
            class="button-block"
            data-bs-toggle="modal"
            data-bs-target="#CategoryModal"
          >
            Category
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-funnel-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
              />
            </svg>
          </button>
        {/if}
        {#if sizes != ""}
          <button
            class="button-block"
            data-bs-toggle="modal"
            data-bs-target="#SizeModal"
          >
            Size
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-funnel-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
              />
            </svg>
          </button>
        {/if}
        {#if colors != ""}
          <button
            class="button-block"
            data-bs-toggle="modal"
            data-bs-target="#ColorModal"
          >
            Color
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-funnel-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
              />
            </svg>
          </button>
        {/if}
      </div>
      <!-- End Search & Filter Area -->
    </div>
  </div>
  <!-- ...:::End Search & Filter Section:::... -->

  <!-- ...:::Start Catagories - 1 Section:::... -->
  <div class="catagories-section section-gap-top-50">
    <div class="container">
      <div class="catagories-wrapper catagories-shop-wrapper">
        {#if firstproduct !== null}
          <div class="catagories-wrapper-content">
            <!-- Start Product Single Item -->
            {#each ten_products as post}
              {#if post != null}
                <div
                  class="single-product-item product-item--style-3 placeholder-glow"
                  style="max-height: 270px;"
                >
                  <a href="/product/{post.no}"
                    >
                    <picture>
                      <source 
                        srcset="https://imagecdn.veeranfashions.com/webp/{post.image.replace("png", "webp")}"
                        type="image/webp"
                        alt="product"
                      >
                      <source 
                        srcset="https://imagecdn.veeranfashions.com/{post.image}"
                        type="image/png"
                      >
                      <img
                        class="placeholder img-max-height rounded"
                        src="https://imagecdn.veeranfashions.com/{post.image}"
                        alt="product"
                        on:load={remove_placeholder}
                      />
                    </picture>
                    </a
                  >
                  <div class="content">
                    <div class="content--left">
                      <p class="title ellipsis">
                        <Link to="/product/{post.no}" class="text-secondary"
                          >{post.name}</Link
                        >
                      </p>
                      <br />
                      <span class="text-colored fw-bolder"
                        >&#8377 <del class="fw-normal text-secondary"
                          >{post.original_price}</del
                        >
                        {post.price}</span
                      >
                    </div>
                    <div class="content--right" hidden>
                      <a
                        href="wishlist"
                        aria-label="Wishlist"
                        class="btn btn--size-33-33 btn--center btn--round btn--color-pink-swan btn--bg-white btn--box-shadow"
                        ><i class="icon icon-carce-heart" /></a
                      >
                    </div>
                  </div>
                </div>
              {/if}
            {/each}
            <!-- ENd Product Single Item -->
          </div>
        {:else}
          <h2 class="text-center pb-5">No More Products to show</h2>
        {/if}
        {#if shop_set == "0"}
          <button class="load-more-btn" id="next">
            <a href="/shop/{page_next}">Next</a></button
          >
        {:else}
          <button class="load-more-btn" id="next">
            <a href="/shop/{page_next}">Next</a></button
          >
          <button
            class="load-more-btn"
            id="previous"
            on:click={() => {
              history.back();
            }}>Previous</button
          >
        {/if}
      </div>
    </div>
  </div>
  <!-- ...:::Start Catagories - 1 Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
              ><path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              /></svg
            >
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/cart" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-cart-fill"
              viewBox="0 0 16 16"
              ><path
                d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
              /></svg
            >
            <br />
            <h6>Cart</h6>
          </Link>
          
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- Categories Modal -->
  <div
    class="modal fade"
    id="CategoryModal"
    tabindex="-1"
    aria-labelledby="CategoryModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-sm modal-notify modal-Success modal-dialog-scrollable"
      role="document"
    >
      <!--Content-->
      <div class="modal-content text-center glass">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading fw-bolder text-colored">Select a Categorie</p>
        </div>

        <div class="modal-body">
          <ul>
            {#each categories as category}
              <li>
                <a href="/shop/filter/{category}"
                  ><button type="button" class="btn load-more-btn"
                    >{category}</button
                  ></a
                >
              </li>
            {/each}
          </ul>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
  <!-- Categories Modal End -->

  <!-- Size Modal -->
  <div
    class="modal fade"
    id="SizeModal"
    tabindex="-1"
    aria-labelledby="SizeModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-sm modal-notify modal-Success modal-dialog-scrollable"
      role="document"
    >
      <!--Content-->
      <div class="modal-content text-center glass">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading fw-bolder text-colored">Select a Size</p>
        </div>

        <div class="modal-body">
          <ul>
            {#each sizes as size}
              <li>
                <a href="/shop/filter/{size}"
                  ><button type="button" class="btn load-more-btn"
                    >{size}</button
                  ></a
                >
              </li>
            {/each}
          </ul>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
  <!-- Size Modal End -->

  <!-- Color Modal -->
  <div
    class="modal fade"
    id="ColorModal"
    tabindex="-1"
    aria-labelledby="ColorModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-sm modal-notify modal-Success modal-dialog-scrollable"
      role="document"
    >
      <!--Content-->
      <div class="modal-content text-center glass">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading fw-bolder text-colored">Select a Color</p>
        </div>

        <div class="modal-body">
          <ul>
            {#each colors as color}
              <li>
                <a href="/shop/filter/{color}"
                  ><button type="button" class="btn load-more-btn"
                    >{color}</button
                  ></a
                >
              </li>
            {/each}
          </ul>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
  <!-- Color Modal End -->

  <footer class="footer-section" />
</main>
